module.exports = "<div class=\"em-widget-error-prompt hide\"> <span></span> </div> ";